// for testing
// require('expose?$!jquery')

require('./styles/main.scss')
require('./js/main.js')
require('./js/plugins.js')
require('./static.js')



// WEBPACK FOOTER //
// ./src/index.js